export function updateProfile(profile) {
  return {
    type: '@auth/UPDATE_PROFILE',
    payload: { profile },
  };
}
export function updateNotifications(notifications) {
  return {
    type: '@auth/UPDATE_NOTIFICATIONS',
    payload: { notifications },
  };
}
export function uploadAvatar(imageUrl) {
  return {
    type: '@auth/UPLOAD_AVATAR',
    payload: { imageUrl },
  };
}
